export interface ColorPaleteType {
  id: string;
  name: string;
}

export const COLOR_PALETTE_TYPES: Array<ColorPaleteType> = [
  {
    id: 'categorical',
    name: 'Categorical',
  },
  {
    id: 'divergent',
    name: 'Divergent',
  },
  {
    id: 'sequential',
    name: 'Sequential',
  },
];

export const DEFAULT_PALETTE_PREVIEW_COLOR = '#E4E7ED';
export const DIVERGENT_PALETTE_MIDDLE_COLOR = '#B1B2BA';
